export const mapObjSizes = {
  S: {
    cam: {
      template: 35,
      alarmIcon: 15,
      fontSize: 9
    },
    level: {
      width: 70,
      height: 16.8,
      fontSize: 9,
      arrowIcon: 14
    }
  },
  L: {
    cam: {
      template: 45.5,
      alarmIcon: 19.5,
      fontSize: 12
    },
    level: {
      width: 100,
      height: 24,
      fontSize: 13,
      arrowIcon: 20
    }
  }
};



// WEBPACK FOOTER //
// ./src/consts/mapObjSizes.js